import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  round,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import TablaRetencionesPago from "./tablaRetencionesDos";
import { RegistrarPagoFCompras } from "./modalRegistrarPagoCompras";

const RegistrarPagodeFactura = (props) => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );

  const headCells = [
    { label: "COD-P", textAlign: "center", width: "60px" },
    { label: "PRODUCTO", textAlign: "center", width: "270px" },
    { label: "CANTIDAD", textAlign: "center", width: "60px" },
    { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
    { label: "UND. ALT.", textAlign: "center", width: "50px" },
    { label: "%IVA", textAlign: "center", width: "50px" },
    { label: "MONTO IVA", textAlign: "center", width: "50px" },
    { label: "SIN IVA", textAlign: "center", width: "50px" },
  ];

  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());

  const txtIdFactura = useRef();
  const txtNumFactura = useRef();
  const cmbTipo = useRef();
  const txtFecha = useRef();
  const txtId = useRef([]);
  const txtTotalreten = useRef();
  const txtCantidad = useRef([]);
  const txtFechafactura = useRef();
  const txtNcontrol = useRef();
  const txtAbono = useRef();
  const txtSaldo = useRef();
  const btnCancela = useRef();
  const txtTotalRetenido = useRef();
  const btnProducto = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtSubTotal = useRef();
  const txtDescuento = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const txtIdNotaEntrega = useRef();
  const cmbMoneda = useRef();
  const txtMontoTotal = useRef();
  const txtIdmoneda = useRef();
  const txtDias = useRef();
  const txtFechaVencimiento = useRef();
  const txtCedRifVendedor = useRef();
  const txtNomVendedor = useRef();

  const [body, setBody] = useState(null);
  const [ivas, setIvas] = useState(0.00);
  const [mivas, setMivas] = useState(0.00);
  const [tipoAgente, setTipoAgente] = useState("");
  const [tasa, setTasa] = useState(0.00);
  const [selectd, setSelectd] = useState(0);
  const [actcredit, setActcredit] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [habilitado, setHabilitado] = useState(false);
  const [valida, setValida] = useState(0);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [habilitadoMod, setHabilitadoMod] = useState(false);
  const [habilitadoTip, setHabilitadoTip] = useState(false);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [indice, setIndice] = useState(null);
  const [idvendedor, setIdvendedor] = useState(null);
  const [numNota, setNumNota] = useState("");
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [idfact, setIdfact] = useState(0);
  const [numfact, setNumfact] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [monto, setMonto] = useState(0.0);
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [visible, setVisible] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [desde, setDesde] = useState(0);
  const [retorno, setRetorno] = useState(0.00);
  const [idAlmacen, setIdAlmacen] = useState(0);
  const [idOpeInve, setIdOpeInve] = useState("");
  const [records, setRecords] = useState([]);
  const [combomoneda, setComboMoneda] = useState([]);
  const [moneda, setMoneda] = useState([]);
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "2",
    descripcion: "DOLARES",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 0.0,
  });

  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoVendedor, setCatalogoVendedor] = useState(false);
  const [catalogoNota, setCatalogoNota] = useState(false);
  const [catalogoFactura, setCatalogoFactura] = useState(false);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Facturas.");
  const [selectp, setSelectp] = useState(0);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");

  const [cmbCedula, setCmbCedula] = useState([
    { value: "J" },
    { value: "V" },
    { value: "G" },
    { value: "P" },
  ]);

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.target.name === "codpedido") {
      /*txtDescripAlmaOrigen.current.value = '';
            setRecords([]);*/
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idfactu") {
          seleccionarRegistro(event.target.value);
        } else if (event.target.name === "idnotaentre") {

        } /*else if (event.target.name === 'codalmadestino') {
            seleccionarAlmacen(event.target.value, 2);
          }*/
      }
    }
  };

  const [habilitadoNU, setHabilitadoNU] = useState(true);

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarClienteinput(rif, event.which);
      }
    }
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Facturas.");
    setBody();
    setActivate(false);
    setOperacion(0);
    setHabilitado(false);
    setHabilitadoMod(false);
    setHabilitadoTip(false);
    setHabilitarMoneda(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setValida(0);
    setHabilitadoProductos(true);
    setTasa(0.00);
    setSelectd(0);
    setSelectp(0);
    setIdvendedor(0);
    setVisible(0);
    setVisibleBtn("visible");
    setMoneda([]);
    setRecords([]);
    setNumNota("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    setIdOpeInve("");
  };

  const onCambioUnidad = (index) => (event) => {
    var data = [...records];
    let precio = 0.0;
    let tasa = moneda.valormoneda;
    let montoiva = 0.0;
    let uni = [];
    let tipounidad = 0;
    let cantie = data[index].cantidadEA;
    //  let valorfactor = 0.00;

    if (parseInt(event.target.value) === parseInt(data[index].idunidadmedida)) {
      precio =
        parseFloat(data[index].costocalculado) *
        (1 + parseFloat(data[index].utipreciomaxi) / 100);
      precio = Math.round(precio * 100) / 100;
      precio = precio * data[index].valormoneda;
      precio = precio / tasa;
      precio = Math.round(precio * 100) / 100;
      //   valorfactor = data[index].cantidadE/data[index].valorfactor;
      montoiva = (precio * data[index].ivaventa) / 100;
      montoiva = Math.round(montoiva * 100) / 100;

      uni = data[index].unidad.reverse();
      tipounidad = 0;
      if (data[index].tipofactor === "1") {
        cantie = parseFloat(data[index].cantidadE / data[index].valorfactor);
        //cantie = Math.round(cantie * 100) / 100;
        cantie = Math.trunc(cantie);
      }
    } else {
      precio =
        data[index].costocalculadoalter *
        (1 + data[index].utipreciomaxialter / 100);
      precio = Math.round(precio * 100) / 100;
      precio = precio * data[index].valormoneda;
      precio = precio / tasa;
      precio = Math.round(precio * 100) / 100;
      //   valorfactor = data[index].valorfactor*data[index].cantidadE;
      montoiva = (precio * data[index].ivaventa) / 100;
      montoiva = Math.round(montoiva * 100) / 100;

      uni = data[index].unidad.reverse();
      tipounidad = 1;
      if (data[index].tipofactor === "0") {
        cantie = parseFloat(data[index].cantidadE / data[index].valorfactor);
        //cantie = Math.round(cantie * 100) / 100;
        cantie = Math.trunc(cantie);
      }
    }

    // data[index].cantidadE = valorfactor;
    data[index].tipounidad = tipounidad;
    data[index].precio = precio;
    data[index].montoiva = montoiva;
    data[index].unidad = uni;
    data[index].total = precio * data[index].cantidad;
    data[index].montoiva =
      (precio * data[index].cantidad * data[index].iva) / 100;
    data[index].cantidadE = cantie;

    setRecords(data);
    //  setTimeout(() => txtCantidad.current[index].focus(), 300);
  };

  const onCambioMoneda = (values) => {
    var tasa = 0.0;
    var data = [...records];
    let precio = 0.0;
    let ivato = 0.00;
    let totalreten = 0.00;
    let retenido = txtTotalreten.current.value;

    for (let i = 0; i < data.length; i++) {

      tasa = data[i].valormoneda;

      if (values.subpredeterminada === true) {
        precio = round(data[i].precio / tasa, 2);
        ivato = round(data[i].montoiva / tasa, 2);
        totalreten = round(retenido, 2);
        setValida(0);
      } else {
        precio = round(data[i].precio * data[i].valormoneda, 2);
        ivato = round(data[i].montoiva * data[i].valormoneda, 2);
        totalreten = round(retenido * tasa, 2);
        setValida(1);
      }

      data[i].precio = precio;
      data[i].montoiva = ivato;
      data[i].total = round(precio * data[i].cantidad, 2);
    }

    setRecords(data);
    calcularTotales(data, totalreten);
  };

  const validarCantidad = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "1,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "cantidad") {
        //var canti = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));
        var canti = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let data = [...records];
        if (canti > data[index].cantidadE) {
          data[index].cantidad = 1.0;
          canti = 1.0;
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "La  cantidad no debe ser mayor a la cantidad existente",
            icono: "informacion",
          });
        }
        //data[index].montodeclarado = event.target.value;
        //data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');
        data[index].cantidad = canti;
        data[index].total = data[index].precio * canti;
        data[index].montoiva =
          (data[index].precio * canti * data[index].iva) / 100;
        setRecords(data);

        if (event.which === 13) {
          if (index < data.length - 1) {
            setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
          } else {
            //btnProducto.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActcredit(1);
    setMostrar(true);
  };

  const handleCloseNo = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActcredit(0);
    setMostrar(true);
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      e.target.value = e.target.value.toUpperCase();
      setRecords([]);
      if (selectp !== 0) {
        txtIdNotaEntrega.current.value = "";
      }
      txtRif.current.value = "";
      cmbRif.current.selectedIndex = -1;
      cmbMoneda.current.selectedIndex = 0;
      setIdCliente();
      setNomCliente("");
      setDirCliente("");
      setNumNota("");
      txtSubTotal.current.value = "";
      txtTotIva.current.value = "";
      txtTotal.current.value = "";

      if (e.target.value === "1") {
        setHabilitadoCli(true);
        setHabilitadoMod(true);
        setHabilitadoProductos(false);
        setHabilitarMoneda(true);
      } else {
        setHabilitadoCli(false);
        setHabilitadoMod(false);
        setHabilitadoProductos(true);
        setHabilitarMoneda(false);
      }
    } else if (e.target.name === "cedula") {
      setIdCliente();
      setNomCliente("");
      setDirCliente("");
    } else if (e.target.name === "idnotaentre") {
      setRecords([]);
      setNomCliente("");
      setDirCliente("");
      /*setNomVendedor('');
            setCedRif('');*/
      setNumNota("");
      txtFecha.current.value = "";
      cmbMoneda.current.selectedIndex = 0;
    }
  };

  const seleccionarClienteinput = (rif, tecla) => {
    let campos = "ag.*";
    let endpoint = `${op.conexion}/api/consulta/clienteporvendedorinput?campos=${campos}&id=${idvendedor}&rifcliente=${rif}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);          
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "proveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idv}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNomVendedor.current.value = response.data.nombre;
            txtCedRifVendedor.current.value = response.data.rif;
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
            setIdvendedor(response.data.idagente);
            setIdAlmacen(response.data.idalmacen);
            setHabilitadoCli(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMoneda = () => {
    let endpoint = `${op.conexion
      }/api/moneda/seleccionarmonedasdos`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            let datamoneda = [];

            for (let i = 0; i < response.data.length; i++) {
              datamoneda.push({
                descripcion: response.data[i].descripcion,
                idmoneda: response.data[i].idmoneda,
                predeterminada: response.data[i].predeterminada,
                simbolo: response.data[i].simbolo,
                subpredeterminada: response.data[i].subpredeterminada,
                valormoneda: response.data[i].valormoneda,
              });
            }
            setMoneda(datamoneda);
            setComboMoneda(datamoneda);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "facturacompra";
    let nomid = "idfacturacompra";
    //let id = id;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNumFactura.current.value = response.data.codigo;
            setNumfact(response.data.codigo);
            setIdfact(response.data.idfacturacompra);
            txtNcontrol.current.value = response.data.numcontrol;
            txtFechafactura.current.value = moment(response.data.fechafactura).format('YYYY-MM-DD');
            seleccionarVendedor(response.data.idproveedor);
            seleccionarMoneda();
            seleccionarDetalle(id, response.data.tasa);
            setTasa(response.data.tasa);
            setHabilitadoTip(false);

          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdFactura.current.value = "";
            txtIdFactura.current.focus();
          }
        }

      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (id, tasac) => {
    let nomtab1 = "facturacompra_detalle";
    let nomtab2 = "facturacompra";
    let nomid = "idfacturacompra";
    let endpoint = `${op.conexion}/api/inventario/seleccionarfactucompradet?id=${id}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            var prod = [];
            let uni = [];

            for (let i = 0; i < response.data.length; i++) {
              if (
                parseInt(response.data[i].idunidadalterna) === 0 ||
                response.data[i].idunidadalterna === null
              ) {
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else {
                if (response.data[i].tipounidad === 0) {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                  ];
                } else {
                  uni = [
                    {
                      idunidad: response.data[i].idunidadalterna,
                      descripcion: response.data[i].descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data[i].idunidadmedida,
                      descripcion: response.data[i].descripcionuni,
                      tipo: "medida",
                    },
                  ];
                }
              }

              let montoiva =
                (response.data[i].punitario * response.data[i].iva) / 100;
              montoiva = Math.round(montoiva * 100) / 100;

              if (montoiva > 0) {
                setIvas(response.data[i].iva);
              } else {
                setIvas(0.00);
              }


              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                nombrecorto: response.data[i].nombrecorto,
                precio: response.data[i].punitario,
                precious: response.data[i].punitario,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                montoiva: response.data[i].cantidad * montoiva,
                total: response.data[i].cantidad * response.data[i].punitario,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: response.data[i].tipounidad,
                valormoneda: response.data[i].valormoneda,
                idmoneda: response.data[i].idmoneda,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
              });
            }
            setRecords(prod);
            seleccionarRetenciones(id, prod, tasac);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarIdProductoM = (index) => (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {

      } else {
        let data = [...records];
        setRecords(data);
      }
    }
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    onCambioMoneda(combomoneda[i]);
  };

  const onChangeValidar = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(1, 2) === "1"
    ) {
      setMostrar(true);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const seleccionarRetenciones = (id, data, tasac) => {
    let endpoint = `${op.conexion}/api/retenciones/seleccionarretenciones?idfacturacompra=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let total = 0.00;
            let monto = 0.00;
            let montod;
            for (let i = 0; i < response.data.length; i++) {
              total = parseFloat(total) + parseFloat(response.data[i].total);
            }
            monto = round(total, 2);
            montod = round(total, 2);
            txtTotalreten.current.value = montod;
            calcularTotales(data, monto);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const calcularTotales = (datos, reten) => {
    let subtot = 0.0,
      descu = 0.0,
      totiva = 0.0,
      totalm = 0.0;
    for (let i = 0; i < datos.length; i++) {
      subtot = subtot + datos[i].total;
      totiva = totiva + datos[i].montoiva;
    }
    totalm = subtot + totiva;
    txtSubTotal.current.value = formatMoneda(
      subtot.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotIva.current.value = formatMoneda(
      totiva.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotal.current.value = formatMoneda(
      totalm.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtTotalRetenido.current.value = formatMoneda(
      reten.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    let mtotalm = totalm - reten;

    txtMontoTotal.current.value = formatMoneda(
      mtotalm.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    let tosaldo = 0.0;
    tosaldo = totalm - reten - props.abono;

    txtAbono.current.value = formatMoneda(
      props.abono.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtSaldo.current.value = formatMoneda(
      tosaldo.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    setMonto(tosaldo);
    setMivas(totiva);
  };

  const imprimirFactura = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(4, 5) === "1"
    ) {
      let fact = 0;
      if (txtIdFactura.current.value !== "") {
        let idnot = txtIdFactura.current.value;

        var reporte = "ReportFacturaEntrega";

        window.open(
          op.reportes +
          "/ventas?afiliado=" +
          afiliado +
          "&reporte=" +
          reporte +
          "&idnota=" +
          idnot,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la Factura !",
          icono: "informacion",
        });
        fact = 1;
      }

      if (fact === 1) {
        txtIdFactura.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };


  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {
          seleccionarRegistro(props.idnot);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Factura de Compra</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12 " style={{ margin: 0 }}>
          <div className="col-md-12 row border-azul mx-auto rounded py-1">
            <div
              className="colfull1070 col-pd-470 mx-auto mb-1 py-1 px-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <fieldset className="col-md-12 mx-auto row border-azul rounded py-2 px-1">
                <legend className="float-none m-0 w-auto fw-bold fs-5">Datos de la Factura</legend>
                <div className="input-group input-group-sm mb-2 col-pd-250 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    N° FACTURA:{" "}
                  </label>
                  <input
                    ref={txtNumFactura}
                    autoComplete="off"
                    disabled={true}
                    type="text"
                    className="form-control fs-6"
                    name="cedula"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onKeyUp={validarCliente}
                    onBlur={validarCliente}
                    onChange={onChange}
                  />
                </div>
                <div className="input-group input-group-sm mb-2 col-pd-200 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    N° CONTROL:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    ref={txtNcontrol}
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div className="input-group input-group-sm mb-2 col-pd-260 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    FECHA FACTURA:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="date"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtFechafactura}
                  />
                </div>
              </fieldset>
            </div>

            <div
              className="colfull1070 col-pd-600 mx-auto row mb-1 py-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <fieldset className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                <legend className="float-none m-0 w-auto fw-bold fs-5">Datos del Proveedor</legend>

                <div className="input-group input-group-sm mb-2 col-pd-230 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CEDULA/RIF:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    ref={txtCedRifVendedor}
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />

                  {operacion === 1 && selectp === 0 ? (
                    <button
                      disabled={operacion === 1 && selectp === 0 ? false : true}
                      type="button"
                      onClick={() => {
                        setTipoAgente("vendedor");
                        setCatalogoVendedor(true);
                      }}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="input-group input-group-sm mb-1 col-pd-570 px-1">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    NOMBRE:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    ref={txtNomVendedor}
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </fieldset>
            </div>

            <div className="colfull col-pd-170 mb-1 ml-auto">
              <div className="input-group input-group-sm">
                <select
                  className="form-control form-control-sm form-select fw-bold"
                  ref={txtIdmoneda}
                  onChange={onChangeMoneda}
                >
                  {combomoneda &&
                    combomoneda.map((item, index) => (
                      <option key={index} value={index}>
                        {" "}
                        {`${item.descripcion} ${item.simbolo}`}{" "}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div
              className="col-md-12 border-azul rounded px-0"
              style={{ backgroundColor: "#d5e9ff" }}
            >
              <TblContainer
                container={{
                  height: 190,
                  width: "100%",
                  overflow: "auto",
                  padding: "2px",
                  fontSizeAdjust: "0.6",
                }}
              >
                <TblHead />
                <TableBody className="overflow-hidden">
                  {records &&
                    records.map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell className="align-middle bg-light text-center p-0 d-flex">
                          <input
                            type="text"
                            style={{
                              borderBottomRightRadius: 0,
                              borderTopRightRadius: 0,
                              height: "37px",
                            }}
                            disabled={habilitadoProductos}
                            ref={(el) => (txtId.current[index] = el)}
                            className="form-control form-control-sm bg-light text-center fs-6"
                            defaultValue={item.idproducto}
                            onKeyUp={validarIdProductoM(index)}
                            onBlur={validarIdProductoM(index)}
                          />
                        </TableCell>

                        <TableCell
                          className="align-middle bg-light text-start p-0 pl-2"
                          style={{ width: "270px" }}
                        >
                          {item.nombrecorto}
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light d-fex justify-content-center p-0"
                          style={{ width: "60px" }}
                        >
                          <input
                            type="text"
                            className="form-control form-control-sm bg-light text-right fs-6"
                            id="cantidad"
                            disabled={!habilitadoMod}
                            defaultValue={formatMoneda(
                              item.cantidad
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                            ref={(el) => (txtCantidad.current[index] = el)}
                            onFocus={seleccionarCampo}
                            onKeyUp={validarCantidad(index)}
                            onBlur={validarCantidad(index)}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "50px" }}
                        >
                          {formatMoneda(
                            item.precio
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light p-0"
                          style={{ width: 50 }}
                        >
                          <select
                            className="form-control form-control-sm fs-6"
                            style={{ width: "100%" }}
                            disabled={habilitadoProductos}
                            onChange={onCambioUnidad(index)}
                          >
                            {item.unidad &&
                              item.unidad.map((item2, x) => (
                                <option key={x} value={item2.idunidad}>
                                  {" "}
                                  {item2.descripcion}{" "}
                                </option>
                              ))}
                          </select>
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "50px" }}
                        >
                          {formatMoneda(
                            item.iva
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "50px" }}
                        >
                          {formatMoneda(
                            item.montoiva
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "50px" }}
                        >
                          {formatMoneda(
                            item.total
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
            </div>

            <div className="col-md-12 row m-0 px-0">
              <div className="col-md-8 mt-auto px-0">
                <div className='col-md-12 px-0 border-azul p-1 rounded border-3'>
                  <h4 className="fw-bold">RETENCIONES <i className="fas fa-arrow-down" /></h4>
                </div>
                <div className='col-md-12 px-0 mx-0 rounded'>
                  <TablaRetencionesPago
                    idfact={props.idnot}
                    tasa={tasa}
                    val={valida}
                  />
                </div>
              </div>
              <div
                className="col-md-4 border-azul rounded p-2 shadow px-1"
                style={{ backgroundColor: "#dbeeff" }}
              >
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    SUBTOTAL: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtSubTotal}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL IVA: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtTotIva}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtTotal}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL RETENIDO: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtTotalRetenido}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <input type="hidden" ref={txtTotalreten} />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    MONTO TOTAL: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtMontoTotal}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    ABONO: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtAbono}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div
                  className="input-group input-group-sm  col-md-12"
                  style={{ fontSizeAdjust: "0.7" }}
                >
                  <label
                    className="input-group-text bg-transparent border-0"
                    id="inputGroup-sizing-sm"
                  >
                    SALDO: {moneda.simbolo}
                  </label>

                  <input
                    type="text"
                    disabled
                    ref={txtSaldo}
                    className="form-control bg-transparent text-right rounded border-0 fs-5 fw-bold"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Registrar Pago</i>{" "}
        </button>
        <button
          onClick={imprimirFactura}
          style={{ margin: "5px" }}
          className="btn btn-sm btn-primary rounded-pill"
          title="Imprimir Nota de Entrega"
        >
          <i className="fa fa-print"> Imprimir</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <RegistrarPagoFCompras
        show={mostrar}
        ope={1}
        idfactu={idfact}
        numfactu={numfact}
        siescredit={actcredit}
        idclient={idvendedor}
        idvendedor={idVendedor}
        onRenderizar={cerrarModal}
        monto={monto}
        iva={ivas}
        montoiva={mivas}
        abono={props.abono}
        onHideCancelar={() => {
          setMostrar(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default RegistrarPagodeFactura;



// WEBPACK FOOTER //
// ./src/components/finanzas/registrarPagoFactura.js